// extracted by css-extract-rspack-plugin
export default {"actionButtonWrapper":"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__actionButtonWrapper-e6DVX2","iconContainer":"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__iconContainer-gs_Z50","active":"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__active-ewkxeq","badgeTopRight":"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__badgeTopRight-NHu_Cc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"actionButtonWrapper\":\"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__actionButtonWrapper-e6DVX2\",\"iconContainer\":\"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__iconContainer-gs_Z50\",\"active\":\"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__active-ewkxeq\",\"badgeTopRight\":\"src-shared-components-MainLayout-components-TopDock-components-ActionButton-ActionButton-module__badgeTopRight-NHu_Cc\"}";
        // 1793872695641
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  